import Icon from '@ant-design/icons';
import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

const AddChatSVG = () => (
  <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_9213_2083)'>
      <path
        d='M16.5688 8.01952C14.2481 7.86086 11.9808 8.70619 10.3434 10.3429C8.70609 11.9809 7.85943 14.2502 8.01943 16.5689C8.31343 20.8049 12.0488 24.0002 16.7081 24.0002H20.4548C22.5088 24.0002 23.9994 22.2822 23.9994 19.9155V16.2149C24.0001 11.9089 20.7361 8.30886 16.5688 8.01952ZM22.0001 19.9155C22.0001 21.1815 21.3934 22.0002 20.4554 22.0002H16.7088C13.0541 22.0002 10.2388 19.6575 10.0154 16.4309C9.89476 14.6895 10.5294 12.9862 11.7581 11.7582C12.8874 10.6289 14.4181 10.0009 16.0108 10.0009C16.1501 10.0009 16.2901 10.0055 16.4301 10.0155C19.5534 10.2322 22.0001 12.9555 22.0001 16.2155V19.9162V19.9155ZM19.3334 16.0002C19.3334 16.5529 18.8861 17.0002 18.3334 17.0002H17.0001V18.3335C17.0001 18.8862 16.5528 19.3335 16.0001 19.3335C15.4474 19.3335 15.0001 18.8862 15.0001 18.3335V17.0002H13.6668C13.1141 17.0002 12.6668 16.5529 12.6668 16.0002C12.6668 15.4475 13.1141 15.0002 13.6668 15.0002H15.0001V13.6669C15.0001 13.1142 15.4474 12.6669 16.0001 12.6669C16.5528 12.6669 17.0001 13.1142 17.0001 13.6669V15.0002H18.3334C18.8861 15.0002 19.3334 15.4475 19.3334 16.0002Z'
        fill='white'
      />
    </g>
    <defs>
      <clipPath id='clip0_9213_2083'>
        <rect width='16' height='16' fill='white' transform='translate(8 8)' />
      </clipPath>
    </defs>
  </svg>
);

export const AddChatIcon = (props: Partial<CustomIconComponentProps>) => <Icon component={AddChatSVG} {...props} />;
